import { Box, Button, Stack, Typography } from '@mui/material';
import { Image, ResponsiveContainer } from 'components-new';
import ReactPlayer from 'react-player';
import { getVideoLink } from '@/components/util';

type Props = {
  gallery: string[];
  tour?: any;
  onClick: (index: number) => void;
};

export default function GalleryThumbnails({ gallery, tour, onClick }: Props) {
  const videoUrl = getVideoLink(tour.videoUrl);

  const hasVideo = Boolean(videoUrl) && false;
  const showViewMore = gallery.length > (hasVideo ? 4 : 5);

  const galleryThumbs = hasVideo ? gallery.slice(0, 3) : gallery.slice(1, showViewMore ? 4 : 5);

  return (
    <Box py={2}>
      <Box
        sx={{
          display: 'grid',
          gap: 1,
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
          },
        }}
      >
        {hasVideo ? (
          <ResponsiveContainer
            ratio="1/1"
            containerStyles={{
              borderRadius: 2,
              overflow: 'hidden',
            }}
          >
            <ReactPlayer width="100%" height="100%" controls url={videoUrl} />
          </ResponsiveContainer>
        ) : (
          <Box position="relative">
            <Image
              alt="photo"
              src={gallery[0]}
              ratio="1/1"
              objectFit="cover"
              onClick={() => onClick(0)}
              sx={{
                borderRadius: 2,
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8,
                },
              }}
            />
            <Stack
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                paddingX: 4,
                paddingY: 2,
                color: '#fff',
                borderRadius: '0 0 5px 5px',
                background: 'rgba(0,0,0,0.5)',
                backdropFilter: 'blur(2px)',
              }}
            >
              <Typography variant="h3">{tour?.title}</Typography>
              <Typography variant="h6" fontWeight="lighter" sx={{ mt: '0 !important' }}>
                {tour?.images?.length} Pictures
              </Typography>
            </Stack>
          </Box>
        )}

        <Box
          sx={{
            display: 'grid',
            gap: 1,
            gridTemplateColumns: 'repeat(2, 1fr)',
          }}
        >
          {galleryThumbs.map((photo, index) => (
            <Image
              alt="photo"
              key={photo}
              src={photo}
              ratio="1/1"
              objectFit="cover"
              onClick={() => onClick(index + 1)}
              sx={{
                borderRadius: 2,
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8,
                },
              }}
            />
          ))}

          {gallery.length > (hasVideo ? 4 : 5) && (
            <Box
              position="relative"
              sx={{
                borderRadius: 2,
                overflow: 'hidden',
              }}
            >
              <Image
                alt="photo"
                src={gallery[hasVideo ? 3 : 4]}
                ratio="1/1"
                objectFit="cover"
                sx={{
                  borderRadius: 2,
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.8,
                  },
                }}
              />
              <Button
                onClick={() => onClick(4)}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  color: '#fff',
                  background: 'rgba(0,0,0,0.5)',
                  backdropFilter: 'blur(2px)',
                  '&:hover': {
                    background: 'rgba(0,0,0,0.5)',
                    opacity: 0.8,
                  },
                }}
                startIcon={<i className="fa-regular fa-eye" />}
              >
                View more
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
